import NewsStreamComponent from './NewsStreamComponent';

export default {
    NewsStreamComponent, // 信息流首条，推荐位
};
